import { Bell } from "lucide-react";

import { useNavigate } from "react-router-dom";

import { cn } from "@/shared/lib/utils";
import { Button, type ButtonProps } from "@/shared/ui/button";
import { useUnreadNotificationsCount } from "@/entities/notification/api";

interface NotificationsButtonProps extends ButtonProps {
  isMobile?: boolean;
}

export const NotificationsButton = ({
  className,
  variant = "default",
  isMobile = false,
  ...props
}: NotificationsButtonProps) => {
  const navigate = useNavigate();
  const { data, isLoading } = useUnreadNotificationsCount();

  const unreadCount = data?.data?.count || 0;

  return (
    <Button
      variant={variant}
      size="icon"
      className={cn(
        "relative px-3",
        {
          "bg-black text-white": !variant,
          "max-md:hidden": !isMobile,
          "flex-grow": isMobile,
        },
        className,
      )}
      onClick={() => navigate("/notifications")}
      {...props}
    >
      {!isLoading && unreadCount > 0 && (
        <span className="absolute -right-3 -top-3 grid size-6 place-items-center rounded-full bg-[#E11D48] text-[10px] text-white">
          {unreadCount > 99 ? "99+" : unreadCount}
        </span>
      )}
      <Bell />
    </Button>
  );
};
